import { render, staticRenderFns } from "./ReportTemplateV2.vue?vue&type=template&id=56c6f4fb&scoped=true"
import script from "./ReportTemplateV2.vue?vue&type=script&lang=js"
export * from "./ReportTemplateV2.vue?vue&type=script&lang=js"
import style0 from "./ReportTemplateV2.vue?vue&type=style&index=0&id=56c6f4fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6f4fb",
  null
  
)

export default component.exports